import { render, staticRenderFns } from "./callDetailsRow.vue?vue&type=template&id=5c290428&"
import script from "./callDetailsRow.vue?vue&type=script&lang=js&"
export * from "./callDetailsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "callDetailsRow.vue"
export default component.exports